'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../providers/ClaimBuilder/index.js');
var useAnalytics = require('../../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../../providers/titan/useTitanAnalytics.js');
var SessionContext = require('../../../providers/SessionContext.js');
var useSubmitClaim = require('../useSubmitClaim.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ItemClaimSummaryContext = /*#__PURE__*/React.createContext(null);
const useItemClaimSummary = () => {
  const context = React.useContext(ItemClaimSummaryContext);
  if (!context) {
    throw new Error('No context provided for ItemClaimSummary provider');
  }
  return context;
};
const ItemClaimSummaryProvider = _ref => {
  let {
    children,
    value: {
      itemClaims,
      useCreateClaimMutation,
      appeasements
    }
  } = _ref;
  const {
    state: {
      claimType,
      claimAmount
    },
    getFullItemDetails,
    handleNavigateBack,
    handleSubmitClaimSuccess
  } = index.useClaimBuilder();
  const [submitClaim, submitClaimStatus] = useSubmitClaim["default"]({
    useCreateClaimMutation
  });
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const [appeasement, setAppeasement] = React.useState(appeasements !== null && appeasements !== void 0 && appeasements.enabled && appeasements !== null && appeasements !== void 0 && appeasements.options ? {
    type: appeasements.options[0].type
  } : undefined);
  const itemSummaries = React.useMemo(() => Object.keys(itemClaims).map(itemClaimUid => {
    const itemClaim = itemClaims[itemClaimUid];
    const itemDetails = getFullItemDetails(itemClaim.uid, itemClaim.packageId);
    if (!itemDetails) throw new Error('No item details');
    return {
      itemClaimUid,
      itemClaim,
      itemDetails: {
        ...itemDetails,
        quantity: itemClaim.quantity
      }
    };
  }), [itemClaims, getFullItemDetails]);
  const onSubmit = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.REVIEW_SUBMIT_CLICK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY,
      order_number: orderNumber,
      claim_reason: claimType,
      page_step: useAnalytics.ClaimsPageStep.REVIEW_SUBMIT
    });
    submitClaim({
      appeasement
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
  };
  const onBack = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.REVIEW_SUBMIT_BACK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY,
      order_number: orderNumber,
      claim_reason: claimType,
      page_step: useAnalytics.ClaimsPageStep.REVIEW_SUBMIT
    });
    handleNavigateBack();
  };
  React.useEffect(() => {
    if (submitClaimStatus.complete && submitClaimStatus.success) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'order_completed',
        properties: {
          revenue: claimAmount,
          products: itemSummaries.map(_ref2 => {
            let {
              itemDetails
            } = _ref2;
            return {
              product_id: itemDetails.itemId,
              sku: itemDetails.sku,
              name: itemDetails.name
            };
          }),
          extra_properties: [{
            key: 'request_result',
            value: 'SUCCESS'
          }, {
            key: 'appeasement_type',
            value: appeasement === null || appeasement === void 0 ? void 0 : appeasement.type
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.REVIEW_CONFIRMATION_CHECKED,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY,
        order_number: orderNumber,
        claim_reason: claimType,
        page_step: useAnalytics.ClaimsPageStep.REVIEW_SUBMIT
      });
      handleSubmitClaimSuccess();
    }
    if (submitClaimStatus.complete && submitClaimStatus.error) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'order_completed',
        properties: {
          revenue: claimAmount,
          products: itemSummaries.map(_ref3 => {
            let {
              itemDetails
            } = _ref3;
            return {
              product_id: itemDetails.itemId,
              sku: itemDetails.sku,
              name: itemDetails.name
            };
          }),
          extra_properties: [{
            key: 'request_result',
            value: 'ERROR'
          }, {
            key: 'appeasement_type',
            value: appeasement === null || appeasement === void 0 ? void 0 : appeasement.type
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.REVIEW_SUBMIT_FAILURE,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ITEM_CLAIM_SUMMARY,
        order_number: orderNumber,
        claim_reason: claimType,
        page_step: useAnalytics.ClaimsPageStep.REVIEW_SUBMIT
      });
    }
  }, [submitClaimStatus, logEvent, titan, claimType, claimAmount, itemSummaries, orderNumber, handleSubmitClaimSuccess, appeasement === null || appeasement === void 0 ? void 0 : appeasement.type]);
  return /*#__PURE__*/React__default["default"].createElement(ItemClaimSummaryContext.Provider, {
    value: {
      itemSummaries,
      submitClaimStatus,
      onBack,
      onSubmit,
      appeasement,
      setAppeasement,
      submitting: submitClaimStatus.loading || submitClaimStatus.called && !submitClaimStatus.error
    }
  }, children);
};

exports.ItemClaimSummaryContext = ItemClaimSummaryContext;
exports.ItemClaimSummaryProvider = ItemClaimSummaryProvider;
exports.useItemClaimSummary = useItemClaimSummary;
